import { render, staticRenderFns } from "./OrganismTemplateDetail.vue?vue&type=template&id=5442a814&scoped=true&"
import script from "./OrganismTemplateDetail.vue?vue&type=script&lang=js&"
export * from "./OrganismTemplateDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrganismTemplateDetail.vue?vue&type=style&index=0&id=5442a814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5442a814",
  null
  
)

export default component.exports